import { action, observable } from "mobx"
import React                  from "react"
import ProductModel           from "sdk/ProductModel"
import convertBoolean         from "util/convertBoolean"
import { Label, Icon }        from "semantic-ui-react"
import shop                   from "shop/shop"
import _                      from "lodash"

export default class ProductModelBase extends ProductModel {

  @observable unit_multi


  constructor( data ) {
    data = convertBoolean( data )
    super( data )
    this.title = this.desc.short_des
    this.description = this.desc.des
    this.extras = this.extras || {}
    this.pinfos = this.pinfos || {}


    // this.title = this.title.split( "," )[ 0 ]
    this.excerpt = this.description // .split('. ')[0] + "."

    this.pinfos = data.pinfos || {}

    this.salePercent = false
    this.salePercentReal = Math.abs( Number( this.pinfos.rabatt ) / 100 )
    this.originalPrice = this.price
    if ( this.pinfos && this.pinfos.rabatt ) {
      this.salePercent = Math.round( Math.abs( this.pinfos.rabatt ) ) + " %"
      this.originalPrice = Number( this.price / (1 - this.salePercentReal) ).toFixed( 2 )
      if ( this.pinfos.rabatt < 0 ) {
        this.extras.sale = true
      }
    }

    this.extraValue = {}
    this.extraText = {}
    Object.entries( this.extras ).forEach( ( [key, extraItem] ) => {
      if ( !extraItem || !extraItem.value ) {
        this.extraText[ key ] = extraItem
        this.extraValue[ key ] = extraItem
      } else {
        this.extraText[ key ] = extraItem && extraItem.value && extraItem.value.value
        this.extraValue[ key ] = extraItem && extraItem.value && extraItem.value.text
      }
    } )

    // fix VE
    this.quantities = _.filter( this.quantities, q => {
      return q.multi !== 0
    } )

    this.quantityById = {}

    if ( this.quantities ) {
      this.quantities.forEach( q => {
        this.quantityById[ q.map_desc_id ] = q
      } )
    }

    //SALE
    this.isSale = data.extras.sale
    this.canBeBought = !!this.price

    const catId = this.cats && this.cats[ 0 ] && this.cats[ 0 ].cat_id

    this.category = shop.categoriesById.get( catId ) || { map_id: catId }

    this.categoryDict = {}
    this.cats.forEach( c => {
      let cat_id = c.cat_id
      let category = shop.categoriesById.get( catId )
      if ( category ) {
        let parents = category.getParents()
        if ( parents ) {
          parents.forEach( parentId => {
            this.categoryDict[ parentId ] = true
          } )
        }
      }

    } )
    this.smallestQuantity = this.quantities[ 0 ]

    // fix VE
    this.quantities = _.filter( this.quantities, q => {
      if ( this.smallestQuantity.multi > q.multi ) {
        this.smallestQuantity = q
      }
      return q.multi !== 0
    } )
    if ( this.quantities.length > 0 ) {
      // Re-Select first quantity
      this.unit_id = this.quantities[ 0 ].map_desc_id
      this.unit_multi = this.quantities[ 0 ].multi
    } else {
      this.invalid = true
      console.error( `article ${this.article_nr} has no quantities available` )
    }

    this.baseUnitDisplayName = this.extraValue.baseUnitDisplayName || this.baseunit_des || this.baseunit || "Stück"
  }

  @action
  createWarnings() {
    let validCount = this.validateCount( this.count )
    if ( !validCount ) this.warning = translate( "Maximale Abnahmemenge erreicht" )
    if ( validCount ) this.warning = false
    console.log( "CHECK WARNINGS", this.warning )

  }

  validateCount( count ) {
    return true
  }

  onChange = ( { count } ) => {
    return true
  }

  getNotice = ( size ) => {
    let product = this

    const categoryName = this.category && this.category.desc && this.category.desc.short_des.trim()

    const yellow = {}
    const red = {}

    const default_yellow = 1
    const default_red = 0

    // check special conditions
    const yellowCount = yellow[ categoryName ] || default_yellow || 0
    const redCount = red[ categoryName ] || default_red || 0

    const stock = this.stock
    const deliveryDate = this.extras.liefab

    if ( size === "tiny" ) {
      if ( deliveryDate ) {
        return notice = <span className="availability-product"><Icon name={"truck"} color="blue" title={`${translate( "Lieferbar ab:" )} ${deliveryDate}`} className={"avail-date"}/></span>
      }

      if ( stock <= redCount ) {
        return notice = <span className={"availability-product avail-none"}><Icon color="blue" name="truck" title={`${translate( "derzeit nicht lieferbar – jetzt vorbestellen" )}`}/></span>
      }

      if ( stock <= yellowCount ) {
        return notice = <span className={"availability-product avail-danger"}><Icon color="yellow" name="truck" title={`${translate( "wenig auf Lager" )}`}/></span>
      }

      if ( stock > yellowCount ) {
        return notice = <span className={"availability-product black-70   ttu"}><Icon color="green" name="truck" title={translate( "auf Lager" )}/></span>
      }
    }

    if ( deliveryDate ) {
      return notice = <Label color="blue" className={"availability-product avail-date"}><Icon name="truck" title={`${translate( "Lieferbar ab:" )} ${deliveryDate}`}/>{`${translate( "Lieferbar ab:" )} ${deliveryDate}`}</Label>
    }

    if ( stock <= redCount ) {
      return notice = <span className={"availability-product avail-none"}><Icon color="blue" name="truck" title={`nicht auf Lager`}/>derzeit nicht lieferbar – jetzt vorbestellen</span>
    }

    if ( stock <= yellowCount ) {
      return notice = <span className={"availability-product avail-danger"}><Icon color="yellow" name="truck" title={`wenig auf Lager`}/>{translate( "wenig auf Lager" )}</span>
    }

    if ( stock > yellowCount ) {
      return notice = <span className={"availability-product black-70   ttu"}><Icon color="green" name="truck" title="auf Lager"/> {translate( "auf Lager" )}</span>
    }

    let notice = <span className={"availability-product avail-none"}><Icon name="truck" title="Nicht verfügbar" circular/><span>{translate( "derzeit nicht lieferbar – jetzt vorbestellen" )}</span></span>

    if ( stock ) {
      return notice = <span className={"availability-product black-70   ttu"}><Icon title="Auf Lager" name="truck" circular color="green"/>{translate( "auf Lager" )}</span>
    }

    return notice
  }
}



// WEBPACK FOOTER //
// ./src/theme/oehme/shop/ProductModel.js